var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('hdraces-tickets-list',{attrs:{"data-func":_vm.getTickets,"show-user":true}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib??vue-loader-options!./src/components/clients/client/players/player/hdraces-bets.vue?vue&type=template&id=1fabb44b&scoped=true
// module id = aBYB
// module chunks = 0